import { Bell, HeartPulse, UserSquare2 } from "lucide-react"

// type IconName = "shield" | "heartPulse" | "userSquare"

// const icons: Record<IconName, (props: ComponentProps<"svg">) => JSX.Element> = {
//   shield: (props) => <Bell className="text-[white]" />,
//   heartPulse: (props) => <HeartPulse className="text-[white]" />,
//   userSquare: (props) => <UserSquare2 className="text-[white]" />,
// }

export default // FeatureCard Component
function FeatureCard({ title, description, icon = "shield" }) {
  const icons = {
    shield: Bell,
    heartPulse: HeartPulse,
    userSquare: UserSquare2,
  };
  
  const Icon = icons[icon];
  
  return (
    <article className="bg-gradient-to-b from-[#FAFAFA] to-[#F2F2F2] rounded-xl sm:rounded-lg border border-border bg-card/60 p-4 sm:p-3">
      <div className="flex flex-col gap-4 sm:gap-3">
        <div
          aria-hidden="true"
          className="flex h-8 w-8 sm:h-7 sm:w-7 items-center justify-center rounded-lg bg-[#0762D7] text-brand"
        >
          {Icon && <Icon className="h-4 w-4 sm:h-3.5 sm:w-3.5 text-[white]" />}
        </div>
        <div className="space-y-2 sm:space-y-1.5">
          <h3 className="text-base md:text-base sm:text-sm font-semibold tracking-tight">{title}</h3>
          <p className="text-xs sm:text-[11px] leading-relaxed text-muted-foreground">{description}</p>
        </div>
      </div>
    </article>
  );
}